<template>
	<div class="job--edit--languages">
		<div class="job--edit--languages-items">
			<LanguageItem
				v-for="language in languages"
				:key="language.id"
				:language="language"
				:used-languages="usedLanguages"
				@remove="remove(language)"
				@change="languageChanged(language, $event)"
			/>
		</div>
		<div v-if="allValid" class="job--edit--languages-add-container">
			<IconLink
				icon="plus"
				text="Sprache hinzufügen"
				@click="add"
			/>
		</div>
		<div v-if="languages.length > 0 && !motherValid" class="error mt-4 text-right">
			Bitte gib jedenfalls deine Muttersprache/n an.
		</div>
	</div>
</template>
<script>
import _ from "lodash";
import LanguageItem from "./language/LanguageItem";
import {isDefined} from "@/helper/Value";
import {characteristicSingle} from "@/helper/application/Populate";
import {arrayIsNotEmpty} from "@/helper/Array";
import IconLink from "@/vue/common/IconLink";
import {uuid} from "vue-uuid";
import {isMotherLanguage} from "@/helper/application/Language";

export default {

	components: {
		LanguageItem,
		IconLink,
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
	},

	mounted ()
	{
		this.emitChangeEvent();
	},

	data ()
	{
		let languages = [];

		if (this.value)
		{
			_.forEach(this.value, item =>
			{
				let populatedItem = characteristicSingle(item, this.meta, this.meta.language, this.meta.languageType);
				populatedItem.valid = true;

				languages.push(populatedItem);
			});

			languages.sort((a, b) =>
			{
				const motherA = isMotherLanguage(a);
				const motherB = isMotherLanguage(b);

				if (motherA === motherB)
				{
					return a.item.label.localeCompare(b.item.label);
				}

				return motherA ? -1 : 1;
			});
		}
		else
		{
			languages.push({});
		}

		return {
			languages
		};
	},

	computed: {
		usedLanguages ()
		{
			return _.map(this.languages, 'item');
		},
		motherValid ()
		{
			return _
				.filter(this.languages, language => isMotherLanguage(language))
				.length > 0;
		},
		allValid ()
		{
			return _.filter(this.languages, item => item.valid).length === this.languages.length;
		},
		dataValid ()
		{
			return isDefined(this.languages)
				&& arrayIsNotEmpty(this.languages)
				&& this.allValid
				&& this.motherValid;
		},
	},

	methods: {
		add ()
		{
			this.languages.push({
				id: uuid.v4(),
				item: undefined,
				specificities: []
			});

			this.emitChangeEvent(true);
		},
		remove (language)
		{
			this.languages = _.filter(this.languages, l => l.id !== language.id);

			this.emitChangeEvent(true);
		},
		languageChanged (language, data)
		{
			const item = _.find(this.languages, l => l.id === language.id)

			this.$set(item, 'valid', data.valid);
			this.$set(item, 'item', data.item);
			this.$set(item, 'specificities', data.specificities);

			this.emitChangeEvent(true);
		},
		emitChangeEvent (fireChangeEvent)
		{
			const data = this.languages;

			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', data);

			if (fireChangeEvent)
			{
				this.$emit('validChange', data);
			}
		},
	},
}
</script>
